<div *ngIf="element" class="surveys-element-input-long-text" role="group">
    <surveys-element-question-text
        *ngIf="multipartQuestionHeader"
        [text]="multipartQuestionHeader"
        [textSize]="'small'"
        [classes]="['multipart-label']"
    ></surveys-element-question-text>

    <label for="element.id" class="label">
        <div class="label">
            <surveys-element-question-text
                [id]="element.id"
                [text]="element.label[language]"
                [required]="element.required"
            >
            </surveys-element-question-text>
        </div>

        <div class="inputs">
            <div class="input-element text">
                <r-masked-textarea
                    class="long-text"
                    [control]="control"
                    [mask]="false"
                    [shouldFocus]="shouldFocus"
                    [labeledby]="element.id"
                    [maxlength]="maxLength"
                    [type]="'text'"
                    [describedby]="multipartQuestionId ? multipartQuestionId : element.id"
                    (keyUp)="keyMonitor($event)"
                >
                </r-masked-textarea>
            </div>
        </div>
    </label>
    <div class="textArea-button">
        <r-button
            *ngIf="showProceedActions()"
            class="continue-button"
            [e2e]="'button-' + element.id + '-continue'"
            [affirmative]="true"
            [negative]="false"
            [labeledby]="element.id"
            [describedby]="element.id"
            (onClick)="advance()"
        >
            {{ 'surveys.navigation.continue' | translate }}
        </r-button>
    </div>
</div>
